// Species names and aliases from the PC insect station.
export const bugNames = [
  '熊蜂',
  '凹缘菱纹叶蝉',
  '苍蝇',
  '八字地老虎',
  '白纹伊蚊',
  '白翅叶蝉',
  '白肾灰夜蛾',
  '白腹网丛螟',
  '白背飞虱',
  '白环红天蛾',
  '白边地老虎',
  '八点灰灯蛾',
  '白斑黑野螟',
  '白二尾舟蛾',
  '按蚊',
  '艾棕麦蛾',
  '暗黑鳃金龟',
  '草蛉',
  '白点粘夜蛾',
  '白夜蛾',
  '稻绿蝽',
  '菜蝽',
  '豹纹卷野螟',
  '暗步甲',
  '黑暗金龟子',
  '甘薯天蛾',
  '黑绒金龟子',
  '花生棉铃虫',
  '斑螟',
  '椴六点天蛾',
  '草螟',
  '菜螟',
  '负子蝽',
  '稻蝗',
  '二化螟',
  '豆天蛾',
  '翠锈腰青尺蛾',
  '二线绿尺蛾',
  '斑蛾',
  '大黄齿尺蛾',
  '大黑金龟子',
  '槐尺蛾',
  '豆娘',
  '东亚飞蝗',
  '茶黄毒蛾',
  '艾锥额野螟',
  '黑纹黄灯蛾',
  '二点委夜蛾',
  '大草蛉',
  '大蚊',
  '谷螟',
  '草地螟',
  '黑螟蛾',
  '草螟蛾',
  '薄翅天牛',
  '白螟',
  '蛾蠓',
  '蓟马',
  '小蠹虫',
  '跳甲',
  '飞虱',
  '黄曲条跳甲',
  '稻飞虱',
  '金龟子',
  '烟草甲',
  '有翅蚜',
  '叶蝉',
  '绿蝽',
  '拟步甲',
  '螟蛾',
  '蚜虫',
  '灰飞虱',
  '鳃金龟',
  '黑尾叶蝉',
  '果蝇',
  '绿盲蝽',
  '盲蝽',
  '夜蛾',
  '蛾类',
  '小型蛾类',
  '小型黑甲虫',
  '小型植食性甲虫',
  '小型植食性昆虫',
  '小型甲虫',
  '小型黑虫',
  '小型飞虱',
  '小型黑叶甲',
  '黑色小甲虫',
  '谷蠹',
  '杂虫',
]

export const nameMap = {
  '白纹伊蚊（雄）': '白纹伊蚊',
  '黑暗金龟子（暗黑金龟子）': '黑暗金龟子',
  '黑绒金龟': '黑绒金龟子',
  '有翅蚜虫': '有翅蚜',
  '飞虱若虫': '飞虱',
  '小跳甲': '跳甲',
  '蛾类害虫': '蛾类',
  '蛾类成虫': '蛾类',
  '小型蛾类害虫': '小型蛾类',
  '小型螟蛾': '螟蛾',
  '小蛾类': '小型蛾类',
  '黑色金龟子': '金龟子',
  '棕色金龟子': '金龟子',
  '黄褐丽金龟': '金龟子',
  '铜绿金龟': '金龟子',
  '金龟甲': '金龟子',
}
